export enum AceCloudStatusEnum {
  DRAFT = 'Draft',
  SUBMITTED = 'Submitted',
  IN_REVIEW = 'In review',
  APPROVED = 'Approved',
  REJECTED = 'Rejected',
  ACTION_REQUIRED = 'Action Required',
}
